import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface FieldHelpIconProps {
  title: string;
  label: string;
}

const FieldHelpIcon: React.FC<FieldHelpIconProps> = ({ title, label }) => (
  <Tooltip title={title} enterDelay={200}>
    <IconButton
      size="small"
      aria-label={label}
      sx={{ mt: 0.25, color: 'text.secondary' }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
    </IconButton>
  </Tooltip>
);

export default FieldHelpIcon;
